// extracted by mini-css-extract-plugin
export default {"wrapper":"UpdatingState__wrapper--eVPln","clinicName":"UpdatingState__clinicName--lXcV4"};